import { MuiThemeProvider } from '@material-ui/core/styles';
import { StylesProvider } from '@material-ui/styles';

import WebApp from '$app-web/components/web-app';
import ClientProvider from '$app-web/core/client/provider';
import * as fontAwesomeLibrary from '$app-web/utils/font-awesome-library';

import { jss, theme } from './theme';

fontAwesomeLibrary.initialize();

function WebAppContainer() {
    return (
        <MuiThemeProvider theme={theme}>
            {/* @ts-expect-error: Should be removed after refactoring UI elements */}
            <StylesProvider jss={jss}>
                <ClientProvider>
                    <WebApp />
                </ClientProvider>
            </StylesProvider>
        </MuiThemeProvider>
    );
}

export default WebAppContainer;
